import { render, staticRenderFns } from "./RelatedDocEdit.vue?vue&type=template&id=31ac5e2e"
import script from "./RelatedDocEdit.vue?vue&type=script&lang=js"
export * from "./RelatedDocEdit.vue?vue&type=script&lang=js"
import style0 from "./RelatedDocEdit.vue?vue&type=style&index=0&id=31ac5e2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports